/**
 * Shared Suspense fallback for the lazy-loaded standalone views rendered
 * by AppShell (Library, Automations, Invites, Skills, Connected Tools,
 * Inbox, List, Team, …). Extracted to dedupe the identical centered
 * "Loading {label}…" placeholder that previously appeared inline in
 * every `<Suspense fallback={…}>` and pushed AppShell over the
 * 400-line code-locality cap.
 */
export function ViewLoading({ label }: { label: string }) {
  return (
    <div className="flex-1 flex items-center justify-center text-muted-foreground text-sm bg-background">
      Loading {label}...
    </div>
  );
}
